import React, { Component } from 'react';
import { TwitterPicker } from 'react-color';
import { Button, FormGroup, Checkbox, Radio, FormControl, ControlLabel } from 'react-bootstrap';
import Ad from '../Ad';
import AppFooter from '../AppFooter';
import AppHeader from '../AppHeader';
import Panel from '../Panel';
import MetaData from '../SEO/MetaData';
import NavigationYear from '../NavigationYear';
import './PdfGenerator.css';
import CalendarMonth from "../CalendarMonth";
import CalendarMonthCell from '../CalendarMonthCell';
import PaperPreview from '../PaperPreview';

const yearStart = (new Date()).getFullYear()-1;
const yearEnd = (new Date()).getFullYear()+5;
const colors = ['#fec9bf', '#e9def7', '#f7dede', '#fee0a4', '#d5f5c4', '#d4ddfd', '#c1e6e2', '#e3e3e3', '#c9e5f2', '#eddad2'];

class PdfGenerator extends Component {

	constructor(props) {
		super(props);

		this.state = {
			colorOne: '#b7e7e3',
			colorTwo: '#ffe0a6',
			orientation: 'portrait',
			showSchoolHolidays: '',
			showColorPickerOne: '',
			showColorPickerTwo: ''
		}
	}
	componentDidMount() {

	}

	componentDidUpdate(prevProps){
	}


	handleChangeColorOne = (color) => {
		this.setState({ colorOne: color.hex });
	};

	handleChangeColorTwo = (color) => {
		this.setState({ colorTwo: color.hex });
	};

	handleClick (e) {
		let active;

		switch(e) {
			case 'school-holidays':
				active = (this.state.showSchoolHolidays === '') ? 'active ' : '';
				this.setState({ showSchoolHolidays: active });
				break;
			case 'colorOne':
				active = (this.state.showColorPickerOne === '') ? 'active ' : '';
				this.setState({ showColorPickerOne: active });
				break;
			case 'colorTwo':
				active = (this.state.showColorPickerTwo === '') ? 'active ' : '';
				this.setState({ showColorPickerTwo: active });
				break;
			default:
				break;
		}
	}

	handleOrientation = (o) => {
		this.setState({ orientation: o });
	};

	render() {


		// Fake some dummy content for calendar view in panel
		// TODO: Find better solution

		let month = {id: 1, title: 'Monat'};

		let items = [];
		let i = 1;
		let w = 0;

		for(let c = 0; c <= 39; c++) {

			i = (c > 3 && c < 39) ? i+1 : i;

			if(c % 8 === 0) {
				w++;
				items.push(<CalendarMonthCell content={w} />);
				i--;
			} else {
				let content = (i === 0 || i > 30) ? '' : i;
				let weekDay = (c % 8);
				let isPublicHoliday = (i === 15) ? true : false;
				let isLegal = (i === 15) ? true : false;
				let isSchoolHoliday = (i === 27) ? true : false;
				let colors = [
					this.state.colorOne,
					this.state.colorTwo
				];
				items.push(<CalendarMonthCell content={content} weekDay={weekDay} isPublicHoliday={isPublicHoliday} isSchoolHoliday={isSchoolHoliday} isLegal={isLegal} colors={colors} />);
			}

		}


        return (

          <div className="PdfGenerator App">
			  <MetaData year={parseInt(this.props.match.params.year, 10)} isGenerator="true" />

			  <AppHeader year={parseInt(this.props.match.params.year, 10)} />

			  <Ad type="leaderboard" />

			  <main className="container">

				  <NavigationYear year={parseInt(this.props.match.params.year, 10)} region={this.props.match.params.region} onDecrement={this.props.onDecrement} onIncrement={this.props.onIncrement} isGenerator="true" yearStart={yearStart} yearEnd={yearEnd} />


				  <div className="columns">
					  <div className="col left">
						  <Panel width="280px" height="280px" title="Layout">
							  <PaperPreview title={"Kalender " + this.props.match.params.year} orientation={this.state.orientation} />
						  </Panel>

						  <Panel width="280px" height="280px" title="Details">
							  <div className="Calendar">
								  <CalendarMonth month={month}>
									  {items}
								  </CalendarMonth>
							  </div>
						  </Panel>
					  </div>
					  <div className="col right">

						  <h1>Kalender {this.props.match.params.year} zum Ausdrucken</h1>

						  <p>Hier kannst du den Kalender mit den Feiertagen und Schulferien in Österreich nach deinen Wünschen konfigurieren und als PDF downloaden.</p>

						  <form action="https://www.feiertage-oesterreich.at/content/pdf-generator/create.php" method="post">

							  <div className="row">
								  <h3>1. Welche Daten möchtest du anzeigen?</h3>

								  <FormGroup>
									  <Checkbox name="public-holidays" inline>Feiertage</Checkbox>
									  <Checkbox name="school-holidays" inline onChange={()=>this.handleClick('school-holidays')}>Schulferien</Checkbox>

									  <div className={"regions " + this.state.showSchoolHolidays}>
										  <ControlLabel>Bundesland</ControlLabel>
										  <FormControl componentClass="select" placeholder="select" id="region" name="region">
											  <option value="">Bundesland wählen</option>
											  <option value="burgenland">Burgenland</option>
											  <option value="kaernten">Kärnten</option>
											  <option value="noe">Niederösterreich</option>
											  <option value="ooe">Oberösterreich</option>
											  <option value="salzburg">Salzburg</option>
											  <option value="steiermark">Steiermark</option>
											  <option value="tirol">Tirol</option>
											  <option value="vorarlberg">Vorarlberg</option>
											  <option value="wien">Wien</option>
										  </FormControl>
									  </div>


								  </FormGroup>
							  </div>

							  <div className="row">
								  <h3>2. Hoch- oder Querformat?</h3>

								  <FormGroup>
									  <Radio name="orientation" inline onChange={()=>this.handleOrientation('portrait')} value={this.state.orientation}>Hochformat</Radio>
									  <Radio name="orientation" inline onChange={()=>this.handleOrientation('landscape')} value={this.state.orientation}>Querformat</Radio>
								  </FormGroup>

							  </div>

							  <div className="row">
								  <h3>3. Wähle deine Farben!</h3>

								  <FormGroup>
									  <span className={"color " + this.state.showColorPickerOne} id="color-1" onClick={()=>this.handleClick('colorOne')}>
										  <i style={{backgroundColor: this.state.colorOne}}></i> Farbe 1
										   <TwitterPicker color={ this.state.colorOne } onChangeComplete={ this.handleChangeColorOne } colors={colors} />
										  <input type="hidden" name="color-1" id="color-1" value={ this.state.colorOne } />
									  </span>

									  <span className={"color " + this.state.showColorPickerTwo} id="color-2" onClick={()=>this.handleClick('colorTwo')}>
										  <i style={{backgroundColor: this.state.colorTwo}}></i> Farbe 2
										  <TwitterPicker color={ this.state.colorTwo } onChangeComplete={ this.handleChangeColorTwo } colors={colors} />
										  <input type="hidden" name="color-2" id="color-2" value={ this.state.colorTwo } />
									  </span>

								  </FormGroup>
							  </div>

							  <div className="row">
								  <p>Fast geschafft ... Nur noch ein Klick, dann kann's losgehen!</p>
							  </div>

							  <div className="row">
								  <input type="hidden" name="year" id="year" value={this.props.match.params.year} />
								  <Button type="submit" className="submit button red">PDF downloaden</Button>
							  </div>

						  </form>

					  </div>
				  </div>

			  </main>

			  <AppFooter />
          </div>
        );
    }
}

export default PdfGenerator;



// WEBPACK FOOTER //
// ./src/components/Pages/PdfGenerator.js